export default __webpack_public_path__ + "social-image-7d6b60436cfc6e37a453e47ecd3286f8.digested.png";